import { HubConnectionBuilder } from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { ErrorDto, StorySectionDto, UserStatsDto } from '../core/dtos';

export class StoryClient {
  private readonly textSubject = new Subject<string>();
  public text$: Observable<string> = this.textSubject.asObservable();

  private readonly sectionDoneSubject = new Subject<StorySectionDto>();
  public sectionDone$: Observable<StorySectionDto> =
    this.sectionDoneSubject.asObservable();

  private readonly parsingOptionsSubject = new Subject<void>();
  public parsingOptions$: Observable<void> =
    this.parsingOptionsSubject.asObservable();

  private readonly errorSubject = new Subject<ErrorDto>();
  public errors$: Observable<ErrorDto> = this.errorSubject.asObservable();

  private readonly userStatsSubject = new Subject<UserStatsDto>();
  public userStatsSubject$: Observable<UserStatsDto> =
    this.userStatsSubject.asObservable();

  private readonly connectedPromise: Promise<void>;
  private readonly connection = new HubConnectionBuilder()
    .withUrl('/storyhub')
    .build();

  constructor(private readonly storyId: string) {
    this.connectedPromise = this.connection
      .start()
      .catch((err) => console.error(err));

    this.connection.on('sectionPartialText', (text: string) =>
      this.textSubject.next(text)
    );

    this.connection.on('sectionComplete', (data: StorySectionDto) =>
      this.sectionDoneSubject.next(data)
    );

    this.connection.on('startedParsingOptions', () =>
      this.parsingOptionsSubject.next()
    );

    this.connection.on('userStats', (userStats: UserStatsDto) =>
      this.userStatsSubject.next(userStats)
    );

    this.connection.on('error', (err: ErrorDto) => this.errorSubject.next(err));
  }

  public async continueWithChoice(choiceKey: number): Promise<void> {
    await this.connectedPromise;
    this.connection.send('continueStory', this.storyId, choiceKey);
  }

  public async startStory(): Promise<void> {
    await this.connectedPromise;
    this.connection.send('startStory', this.storyId);
  }

  public async getUserStats(): Promise<void> {
    await this.connectedPromise;
    this.connection.send('getUserStats', this.storyId);
  }

  public async regenerateLastSection(): Promise<void> {
    await this.connectedPromise;
    this.connection.send('regenerateLastSection', this.storyId);
  }
}
